// extracted by mini-css-extract-plugin
export default {"avatar":"UserAvatar_avatar__+a+4e","online":"UserAvatar_online__3KPW3"};